import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import {
  Filter,
  FilterInput,
  FilterList,
  FilterOption
} from 'aquilla/core/molecules/Filter';

const StyledFilterInput = styled(FilterInput)`
  width: 100%;
  padding: 7px ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_2B};
  border: ${Spacings.SPACING_1} solid var(--color-i-divider);
`;

const StyFilterList = styled(FilterList)`
  z-index: 1;
  width: max-content !important;
  li:first-child a {
    display: none;
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const Wrapper = styled.div``;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_3B};
  }
`;
const WebFilterContainer = ({
  filterOptions,
  handleClick,
  getFilterValue,
  filterOnClick
}) => {
  return (
    <FilterWrapper>
      {filterOptions.map((item, index) => (
        <Wrapper onClick={handleClick(index)} key={item}>
          <Filter value={getFilterValue(index)} onSelect={filterOnClick}>
            <StyledFilterInput />
            <StyFilterList>
              {filterOptions[index].options.map((valueObj) => (
                <FilterOption
                  value={valueObj.value}
                  label={valueObj.label}
                  key={valueObj.value}
                />
              ))}
            </StyFilterList>
          </Filter>
        </Wrapper>
      ))}
    </FilterWrapper>
  );
};

export default WebFilterContainer;
